import React from 'react';
import { observer as originObserver } from 'mobx-react-lite';

export const observer = (com: React.FC): React.FC => {
    return originObserver(com);
};
